import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/(app)/_auth/settings/communication/notifications",
)({
  loader: () => ({
    crumb: "alfred.settings.nav.communicationNotifications.label",
  }),
})
